import React from "react"
import Scrollspy from "react-scrollspy"
import { Navbar, Nav } from "react-bootstrap"
import Scroller from './scroller'
import Logo from '../images/logo.svg'
import { Link } from "gatsby"

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    Scroller.handleAnchorScroll = Scroller.handleAnchorScroll.bind(this);
  }

  render() {
    return (
      <>
        <Navbar className="navbar navbar-expand-lg navbar-light fixed-top py-4" id="mainNav" expand="lg"
          collapseOnSelect={true}
        >
          <div className="container">
            <Link to="/" className="navbar-brand js-scroll-trigger" href="/">
              <img src={Logo} alt="Logo" className="img-fluid" />
            </Link>
            <Navbar.Toggle aria-controls="navbarResponsive"/>
            <Navbar.Collapse id="navbarResponsive">
              <Nav className="navbar-nav ml-auto my-2 my-lg-0">
                <Scrollspy className="navbar-nav" items={["mission", "expertise", "donnees", "medias"]} currentClassName="active" rootEl={"#mainNav"} offset={-75}>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#mission" onClick={Scroller.handleAnchorScroll}>Mission</Nav.Link>
                  </li>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#expertise" onClick={Scroller.handleAnchorScroll}>Expertise</Nav.Link>
                  </li>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#application" onClick={Scroller.handleAnchorScroll}>App météo</Nav.Link>
                  </li>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#donnees" onClick={Scroller.handleAnchorScroll}>Données</Nav.Link>
                  </li>
                  <li className="nav-item">
                    <Nav.Link className={"js-scroll-trigger"} href="#medias" onClick={Scroller.handleAnchorScroll}>Médias</Nav.Link>
                  </li>
                  <li className="nav-item">
                    <Nav.Link href="mailto:emorin@visionmeteo.com">Nous joindre</Nav.Link>
                  </li>
                </Scrollspy>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </>
    );
  }
}
